import React, { useState } from "react";
import {
  BOOKMARK,
  ASC,
  MATERIAL_LOCATION,
  COURT_LAW,
  NO_DATA,
} from "../../../assets";
import TableComponent from "../../../shared/components/table";
import { Registrar2SearchAssignedColumns } from "../../../shared/components/table/columns/registrar2SearchAssignedColumns";
import { SortingState } from "@tanstack/react-table";
import { Search as SearchIcon } from "lucide-react";

const SearchAssignedCase = () => {
  const [hasResults, setHasResults] = useState(false);
  const [sorting, setSorting] = useState<SortingState>([]);
  const [globalSearch, setGlobalSearch] = useState("");

  const [caseName, setCaseName] = useState("");
  const [appealNumber, setAppealNumber] = useState("");
  const [judicialDivision, setJudicialDivision] = useState("");
  const [court, setCourt] = useState("");

  const mockResults = [
    {
      sn: false,
      parties: "Olugbenga Akintola vs Israel Anyemalu",
      appeal_number: "CV/3047/2018",
      court: "Hon. Ajiwe Ajibola JSC",
      court_number: "Court 5",
      judicial_division: "Enugu",
      progress: "Ongoing",
    },
  ];

  const handleSearch = () => {
    setHasResults(true);
  };

  return (
    <div className="flex flex-col h-full min-h-screen ">
      {/* Header */}
      <div className="bg-white px-8 py-6 border-b border-[#E4E7EC]">
        <h1 className="text-2xl font-bold text-[#101828]">
          Search assigned cases
        </h1>
        <div className="flex items-center gap-x-2 text-sm text-[#475467] mt-4">
          <span className="text-[#98A2B3]">Home</span>
          <span className="text-[#D0D5DD]">{">"}</span>
          <span className="font-medium text-[#101828]">
            Search assigned cases
          </span>
        </div>
      </div>

      {/* Filters */}
      <div className="px-8 py-6 flex flex-col gap-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-4xl">
          <div className="flex items-center gap-3">
            <div className="flex-1 flex items-center px-4 py-3 rounded-lg border border-[#D0D5DD] bg-white">
              <img src={BOOKMARK} alt="" className="w-5 h-5 mr-3" />
              <input
                type="text"
                value={caseName}
                onChange={(e) => setCaseName(e.target.value)}
                placeholder="Case name"
                className="flex-1 text-sm text-[#101828] placeholder:text-[#98A2B3] border-none outline-none"
              />
              <SearchIcon className="w-4 h-4 text-[#98A2B3]" />
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex-1 flex items-center px-4 py-3 rounded-lg border border-[#D0D5DD] bg-white">
              <img src={ASC} alt="" className="w-5 h-5 mr-3" />
              <input
                type="text"
                value={appealNumber}
                onChange={(e) => setAppealNumber(e.target.value)}
                placeholder="Appeal number"
                className="flex-1 text-sm text-[#101828] placeholder:text-[#98A2B3] border-none outline-none"
              />
              <SearchIcon className="w-4 h-4 text-[#98A2B3]" />
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex-1 flex items-center px-4 py-3 rounded-lg border border-[#D0D5DD] bg-white">
              <img src={MATERIAL_LOCATION} alt="" className="w-5 h-5 mr-3" />
              <input
                type="text"
                value={judicialDivision}
                onChange={(e) => setJudicialDivision(e.target.value)}
                placeholder="Judicial division"
                className="flex-1 text-sm text-[#101828] placeholder:text-[#98A2B3] border-none outline-none"
              />
              <SearchIcon className="w-4 h-4 text-[#98A2B3]" />
            </div>
          </div>

          <div className="flex items-center gap-3">
            <div className="flex-1 flex items-center px-4 py-3 rounded-lg border border-[#D0D5DD] bg-white">
              <img src={COURT_LAW} alt="" className="w-5 h-5 mr-3" />
              <input
                type="text"
                value={court}
                onChange={(e) => setCourt(e.target.value)}
                placeholder="Court"
                className="flex-1 text-sm text-[#101828] placeholder:text-[#98A2B3] border-none outline-none"
              />
              <SearchIcon className="w-4 h-4 text-[#98A2B3]" />
            </div>
          </div>
        </div>

        <div className="flex justify-end max-w-4xl">
          <button
            onClick={handleSearch}
            className="px-12 py-3 rounded-lg bg-[#00B074] text-white text-sm font-semibold hover:bg-[#009060] transition-colors"
          >
            Search
          </button>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 px-8 pb-10">
        {hasResults ? (
          <div className="bg-white rounded-xl p-6">
            {/* Top search */}
            <div className="w-full max-w-xs relative mb-6">
              <input
                type="text"
                placeholder="Search"
                value={globalSearch}
                onChange={(e) => setGlobalSearch(e.target.value)}
                className="w-full pl-4 pr-10 py-2.5 rounded-lg border border-[#D0D5DD] bg-white text-sm placeholder:text-[#98A2B3] focus:outline-none focus:border-[#00B074]"
              />
              <SearchIcon className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-[#98A2B3]" />
            </div>

            <TableComponent
              DATA={mockResults}
              // @ts-ignore
              COLUMNS={Registrar2SearchAssignedColumns}
              sorting={sorting}
              setSorting={setSorting}
            />

            {/* Pagination */}
            <div className="flex items-center justify-end gap-x-4 mt-6 text-sm text-[#475467]">
              <span>Page 1 of 10</span>
              <div className="flex items-center gap-x-2">
                <button className="px-3 py-1.5 border border-[#D0D5DD] rounded hover:bg-gray-50">
                  Previous
                </button>
                <button className="px-3 py-1.5 border border-[#D0D5DD] rounded hover:bg-gray-50">
                  Next
                </button>
              </div>
              <div className="flex items-center gap-x-2">
                <span>Entries per page: 10</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center h-[60vh] gap-y-4">
            <img src={NO_DATA} alt="No Data" className="w-[200px] h-[200px]" />
            <span className="text-[#101828] font-medium">
              You have not created any case folder
            </span>
            <button className="flex items-center gap-2 px-5 py-2 border border-[#D0D5DD] rounded-lg text-sm font-medium text-[#101828] bg-white hover:bg-gray-50">
              <span className="text-xl leading-none">+</span>
              <span>Search Cases</span>
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchAssignedCase;
